import { motion } from "framer-motion";
import { featureByKey } from "@/components/companion/features";

// Ellie's optional, dismissible feature suggestion shown under her message.
export const SuggestionCard = ({ suggest, onOpen, onDecline }) => {
  const f = featureByKey(suggest?.area);
  if (!f || suggest.status === "declined") return null;
  const { Icon } = f;
  return (
    <motion.div data-testid={`suggestion-card-${f.key}`} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, delay: 0.2 }}
      className="fio-glass ml-1 mt-2 flex max-w-[85%] items-center gap-3 rounded-2xl px-3.5 py-2.5">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/12 text-primary"><Icon className="h-4 w-4" strokeWidth={1.75} /></span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground">{f.label}</p>
        {suggest.reason && <p className="text-xs leading-snug text-muted-foreground">{suggest.reason}</p>}
      </div>
      <button data-testid="suggestion-open" onClick={() => onOpen(f.key)} className="rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:bg-primary/90">Open</button>
      {suggest.status !== "opened" && (
        <button data-testid="suggestion-decline" onClick={onDecline} className="text-xs font-medium text-muted-foreground hover:text-foreground">Not now</button>
      )}
    </motion.div>
  );
};
